import { Loading } from 'element-ui';
import { Message } from 'element-ui';

export default {
  loadingInstance: null,
  loading () {

    this.loadingInstance = Loading.service({ fullscreen: true, text: "加载中..." });
  },

  showWarning (msg) {
    console.log(msg)
    Message({
      message: msg,
      showClose: true,
      duration: 2000,
      type: 'warning'
    })
  },

  showSuccess (msg) {
    Message({
      message: msg,
      showClose: true,
      duration: 2000,
      type: 'success'
    })
  },

  hide() {
    if (this.loadingInstance !== null) {
      this.loadingInstance.close();
    }
  }
}



// WEBPACK FOOTER //
// ./src/utility/toast.js